import styled from 'styled-components';
import { color, displaySoft, label, bp } from '../../styles/tokens';
import { Intro } from '../FibraVidro/styles';

export { Intro };

export const Intros = styled.div`
  display: grid;
  gap: 14px;

  ${bp.md} {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
    max-width: none;
  }

  > div {
    margin: 0 auto;
    height: 100%;
    align-items: flex-start;

    ${bp.md} {
      margin: 0;
    }
  }

  margin-bottom: clamp(32px, 5vw, 48px);
`;

// BabyBoomer is the one service with a photo. The source is panoramic
// (1602x577), so the frame takes that ratio instead of the portrait arch —
// cropping it to 3/4 would cut the nail tips off.
export const Feature = styled.div`
  display: grid;
  gap: clamp(24px, 4vw, 36px);
  margin-top: clamp(32px, 5vw, 48px);
  padding: clamp(26px, 4vw, 40px);
  background: ${color.white};
  border: 1px solid ${color.line};
  border-radius: 14px;

  figure {
    /* A flattened crown keeps the arch language at panoramic proportions. */
    border-radius: clamp(48px, 9vw, 110px) clamp(48px, 9vw, 110px) 6px 6px;
    overflow: hidden;
    aspect-ratio: 1602 / 577;
    background: ${color.roseSoft};
    /* Capped so the panoramic photo doesn't dominate the card on desktop. */
    max-width: 620px;
    width: 100%;
    margin: 0 auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center 42%;
    }
  }

  /* Name on the left, the two prices on the right, once there's room. */
  .body {
    display: grid;
    gap: clamp(18px, 3vw, 40px);
    align-items: center;

    ${bp.md} {
      grid-template-columns: 1fr 1.3fr;
    }
  }

  .eyebrow {
    ${label};
    color: ${color.fuchsia};
    margin-bottom: 8px;
  }

  h3 {
    ${displaySoft};
    font-size: clamp(30px, 4vw, 42px);
    color: ${color.ink};
  }
`;
